import {
  Dashboard,
  ExitToApp,
  Home,
  MonetizationOn,
  NewReleases,
  Person,
  SettingsApplications,
  ShoppingCart,
  Star,
  Store,
} from '@mui/icons-material';
import { shopUrl } from '@/constants/environment'; // Avoid circular dependency
import type { MenuItem } from '@/types';

export const mainMenuItems: MenuItem[] = [
  {
    icon: <Person />,
    title: 'Account',
    needsLogin: true,
    children: [
      {
        icon: <Dashboard />,
        title: 'Mein Konto',
        url: `${shopUrl}/mein-konto/`,
      },
      {
        icon: <MonetizationOn />,
        title: 'Bestellungen',
        url: `${shopUrl}/mein-konto/bestellungen/`,
      },
      {
        icon: <SettingsApplications />,
        title: 'Einstellungen',
        url: `${shopUrl}/mein-konto/konto-bearbeiten/`,
      },
      {
        icon: <ExitToApp />,
        title: 'Abmelden',
        url: `${shopUrl}/mein-konto/abmelden/`,
      },
    ],
  },
  {
    icon: <NewReleases />,
    title: 'Neuigkeiten',
    action: 'showAnnouncements',
  },
  {
    icon: <ShoppingCart />,
    title: 'Warenkorb',
    url: `${shopUrl}/warenkorb/`,
  },
  {
    icon: <Home />,
    title: 'Startseite',
    url: `${shopUrl}/`,
  },
  {
    icon: <Store />,
    title: 'Kurse kaufen',
    url: `${shopUrl}/kurse/`,
  },
  {
    icon: <Star />,
    title: 'Themen',
    children: [
      {
        icon: null,
        title: 'Lernplattform',
        url: `${shopUrl}/vorschau/`,
      },
      {
        icon: null,
        title: 'Aufnahmetest',
        url: `${shopUrl}/psychologie-aufnahmetest/`,
      },
      {
        icon: null,
        title: 'Lernen',
        url: `${shopUrl}/lernen/`,
      },
      {
        icon: null,
        title: 'Psychologie',
        url: `${shopUrl}/psychologie-studieren/`,
      },
      {
        icon: null,
        title: 'Unternehmen',
        url: `${shopUrl}/unternehmen/`,
      },
    ],
  },
];

export enum CourseTabList {
  inhalte = 'inhalte',
  fortschritt = 'fortschritt',
  karteikarten = 'karteikarten',
  ergebnisse = 'ergebnisse',
}
